module.exports = __webpack_public_path__ + "static/img/jiaoxue2.761227d5.webp";